import * as ActionTypes from './actionTypes'
import axios from 'axios'
import * as Endpoints from '../Endpoints'
import getRevisionData from "../responses/getRevisionData";
import getTagsData from "../responses/getTagsData";
import {CLEAR_REVISION_INTERVAL_TIMER} from "./actionTypes";
import moment from "moment";
import {resolve} from "chart.js/helpers";

// axios.defaults.withCredentials = true;
const testLaunched=()=>{
    console.log('Redux is implemented successfully');
    return {
        type : ActionTypes.LAUNCH_TEST
    }
}

export const toggleDarkMode=()=>{
    return {
        type: ActionTypes.TOGGLE_DARK_MODE
    }
}
export const launchTest=()=>(dispatch)=>{
    dispatch(testLaunched())
}

export const togglePauseModal=()=>{
    return{
        type : ActionTypes.TOGGLE_PAUSE_MODAL
    }
}

export const deactivateLoading=()=>{
    return{
        type: ActionTypes.DEACTIVATE_LOADING
    }
}

const gotRevision=(revisionData)=>{
    return {
        type: ActionTypes.GET_REVISION,
        payload : revisionData
    }
}

const getRevisionLoading=()=>{
    return {
        type : ActionTypes.GET_REVISION_LOADING
    }
}

const getRevisonError=(err)=>{
    return {
        type : ActionTypes.GET_REVISION_ERROR,
        payload : err
    }
}

export const fetchGetRevision=(quizId)=>(dispatch)=>{
    const headers = {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Access-Control-Allow-Origin' : '*'

    };
    dispatch(getRevisionLoading());
    console.log('URL GET REVISION =', Endpoints.endpoint_get_revision+quizId);
    axios.get(Endpoints.endpoint_get_revision+quizId,
        { headers: headers  }
    ).then(res=>{dispatch(gotRevision(res.data.data))})
        .catch(err=>dispatch(getRevisonError(err.response.data.message)));
    // setTimeout(()=>{
    //         dispatch(gotRevision(getRevisionData))
    // },3000)
}

// option = proposition
export const clickQuestionOption=(optionId , questionType)=>{
    return {
        type : ActionTypes.CLICK_QUESTION_OPTION,
        payload : {
            optionId: optionId,
            questionType : questionType
        }
    }
}

export const clickSubQuestionOption=(optionId , questionType , subquestionId)=>{
    return {
        type : ActionTypes.CLICK_SUB_QUESTION_OPTION,
        payload : {
            optionId : optionId,
            questionType : questionType,
            subquestionId : subquestionId
        }
    }
}


export const verifyUserAnswer=()=>{
    return {
            type : ActionTypes.VERIFY_USER_ANSWER
    }
}

export const goNextQuestionRevision=()=>{
    return {
        type : ActionTypes.GO_NEXT_QUESTION_REVISION
    }
}
export const goPreviousQuestionRevision=()=>{
    return {
        type : ActionTypes.GO_PREVIOUS_QUESTION_REVISION
    }
}

export const goNthQuestionRevision=(questionIndex)=>{
    return {
        type : ActionTypes.GO_NTH_QUESTION_REVISION,
        payload : questionIndex
    }
}

export const deleteChoosenOptionsRevision=()=>{
    return {
        type : ActionTypes.DELETE_CHOOSEN_OPTIONS
    }
}

export const setVerifAnswerModeStatus =(status)=>{
    return{
        type : ActionTypes.SET_VERIF_ANSWER_MODE_STATUS,
        payload : status
    }
}


export const incrementRevisionTimer=(questionIndex)=>{
    return{
        type : ActionTypes.INCREMENT_REVISION_TIMER,
        payload : questionIndex
    }
}

export const setIntervalRevisionTimer=(interval)=>(dispatch)=>{
    dispatch(clearRevisionInternalTimer());
    dispatch(setInterval(interval));

}
const setInterval=(interval)=>{
    return {
            type : ActionTypes.SET_INTERVAL_TIMER_REVISION,
            payload : interval
    }
}

export const clearRevisionInternalTimer=()=>{
    return{
        type : ActionTypes.CLEAR_REVISION_INTERVAL_TIMER
    }
}


// MultiSelect Page

const getTagsLoading=()=>{
    return {
        type : ActionTypes.GET_TAGS_LOADING
    }
}

const getTagsError=(err)=>{
    return {
        type : ActionTypes.GET_TAGS_ERROR,
        payload : err
    }
}

const gotTags=(tags)=>{
    return {
        type : ActionTypes.GET_TAGS,
        payload : tags
    }
}

const getModulesLoading=()=>{
    return {
        type : ActionTypes.GET_MODULES_LOADING
    }
}

const getModulesError=(err)=>{
    return {
        type : ActionTypes.GET_MODULES_ERROR,
        payload : err
    }
}

const gotModules=(modules)=>{
    let result= modules.map(module=>{
        return{
            value : module.id ,
            label : module.title,
            children : module.topics.length ? module.topics.map(module=>{
                return {
                    value : module.id,
                    label : module.title,
                    // ACTUALLY ITS JUST THREE LEVELS !
                    children : null
                }
            }) : null
        }
    })
    return {
        type : ActionTypes.GET_MODULES,
        payload : result
    }
}

export const fetchGetTags=()=>(dispatch)=>{
    const headers = {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
    };
    dispatch(getTagsLoading());
    axios.get(Endpoints.endpoint_get_tags,
        { headers: headers  }
    ).then(res=>{dispatch(gotTags(res.data.data))})
        .catch(err=>dispatch(getTagsError(err.response.data.message)));
}

// MODULE SFOR THE CASCADER IN MULTI SELECT
export const fetchGetModules=()=>(dispatch)=>{
    const headers = {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
    };
    dispatch(getModulesLoading());
    axios.get(Endpoints.endpoint_get_all_modules,
        { headers: headers  }
    ).then(res=>{ console.log("Modules =", res.data.data);dispatch(gotModules(res.data.data))})
        .catch(err=>dispatch(getModulesError(err)));
}


export const fetchMultiSelectFormData=()=>(dispatch, getState)=>{
    let tags = getState().multiSelect.tags.data;
    let modules = getState().multiSelect.modules.data;
    if(!tags.length){
        dispatch(fetchGetTags());
    }
    if(!modules.length){
        dispatch(fetchGetModules());
    }
}


export const  postAnswerRevisionLoading=()=>{
    return {
        type : ActionTypes.POST_ANSWER_REVISION_LOADING
    }
}

// POST ANSWER IN REVISION MODE

const postAnswerRevisionError=(err)=>{
    return {
        type : ActionTypes.POST_ANSWER_REVISION_ERROR,
        payload : err
    }
}

const answerPostedRevision=(response)=>{
    return{
        type : ActionTypes.POST_ANSWER_REVISION,
        payload : response
    }
}

const answerPostedRevisionCCQCM=(response)=>{
    return{
        type : ActionTypes.POST_ANSWER_REVISION_CCQCM,
        payload : response
    }
}

export const fetchPostRevisionAnswer=(answer , questionType)=>(dispatch)=>{
    if(questionType==='CCQCM'){
        dispatch(fetchPostRevisionAnswerCCQCM(answer));
    }else{
        dispatch(fetchPostRevisionAnswerQCUQCM(answer));
    }
}

export const fetchPostRevisionAnswerQCUQCM=(answer)=>(dispatch)=>{
    const options= {
        headers : {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
        }
    };
    axios.post(Endpoints.endpoint_post_answer_revision,answer , options)
        .then(res=>dispatch(answerPostedRevision(res.data.data)))
        .catch(err=>{dispatch(postAnswerRevisionError(err.response.data.message))});
}

export const fetchPostRevisionAnswerCCQCM=(answer)=>(dispatch)=>{
    const options= {
        headers : {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
        }
    };
    axios.post(Endpoints.endpoint_post_answer_revision_ccqcm,answer , options)
        .then(res=>dispatch(answerPostedRevisionCCQCM(res.data.data)))
        .catch(err=>{dispatch(postAnswerRevisionError(err.response.data.message))});
}




//  FLAG A QUESTION

const flagQuestionLoading =()=>{
    return {
        type : ActionTypes.FLAG_QUESTION_LOADING
    }
}

const questionFlagged=(response)=>{
    return {
        type : ActionTypes.FLAG_QUESTION,
        payload : response
    }
}

const flagQuestionError =(err)=>{
    return {
        type : ActionTypes.FLAG_QUESTION_ERROR,
        payload : err
    }
}

export const fetchFlagQuestion=(data)=>(dispatch)=>{
    const options= {
        headers : {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
        }
    };
    return new Promise((resolve , reject)=>{
        dispatch(flagQuestionLoading())
        axios.post(Endpoints.endpoint_post_flag_question,data , options)
            .then(res=>{dispatch(questionFlagged(res.data.data)); resolve()})
            .catch(err=>{dispatch(flagQuestionError(err.response.data.message)); reject()});
    })

}


// PLAYLIST STAFF

const getPlaylistsLoading=()=>{
    return {
        type : ActionTypes.GET_PLAYLISTS_LOADING
    }
}

const getPlayListsError=()=>{
    return{
        type : ActionTypes.GET_PLAYLISTS_ERROR
    }
}

const gotPlaylists=(data)=>{
    let result = data.map(playlist=>{
        return {
            label: playlist.name,
            value : playlist.id
        }
    });
    return{
        type : ActionTypes.GET_PLAYLISTS,
        payload: result
    }
}

export const fetchGetUserPlayLists=()=>(dispatch)=>{
       const  headers = {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
        }
    dispatch(getPlaylistsLoading());
    axios.get(Endpoints.endpoint_get_user_playlists,
        { headers: headers  }
    ).then(res=>{dispatch(gotPlaylists(res.data.data))})
        .catch(err=>dispatch(getPlayListsError(err.response.data.message)));
}


const buildQuizLoading=()=>{
    return {
        type : ActionTypes.POST_BUILD_QUIZ_LOADING
    }
}

const quizBuilt=(builtQuiz)=>{
    // open the revison window for that quiz
        let width = window.screen.availWidth;
        let height = window.screen.availHeight;
        window.open(`${process.env.REACT_APP_WEBSITE_URL}/revision/${builtQuiz.id}`,'_blank',"height="+height+",width="+width+", toolbar=no, top=0,left=0,location=no,menubar=no, directories=no, status=no, menubar=no, scrollbars=yes,resizable=no");
    return {
        type : ActionTypes.POST_BUILD_QUIZ,
        paylaod : builtQuiz
    }

}

const buildQuizError=(err)=>{
    return{
        type : ActionTypes.POST_BUILD_QUIZ_ERROR,
        payload: err
    }
}

export const fetchBuildQuiz=(quizData)=>(dispatch)=>{
    const options= {
        headers : {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
        }
    };
    dispatch(buildQuizLoading());
    axios.post(Endpoints.endpoint_post_build_quiz,quizData , options)
        .then(res=>dispatch(quizBuilt(res.data.data)))
        .catch(err=>{dispatch(buildQuizError(err.response.data.message))});
}




// export const fetchAddQuestionToPlaylist=(data)=>(dispatch)=>{
//     const options= {
//         headers : {
//             'Authorization': `Bearer ${localStorage.getItem('token')}`,
//             'Content-Type': 'application/json'
//         }
//     };
//     return new Promise((resolve , reject)=>{
//         dispatch(questionAddedToPlaylistLoading())
//         axios.post(Endpoints.endpoint_post_add_question_to_playlist, data , options)
//             .then(res=>{dispatch(questionAddedToPlayList(res.data.data)); resolve()})
//             .catch(err=>{dispatch(questionAddedToPlaylistError(err.response.data.message)); reject()});
//     })
//
// }

export const goNthSubQuestion=(index)=>{
    return {
        type : ActionTypes.GO_NTH_SUB_QUESTION,
        payload : index
    }
}

export const goNextSubQuestion=()=>{
    return {
        type : ActionTypes.GO_NEXT_SUB_QUESTION
    }
}


export const addQuestionToPlaylistLoading=()=>{
    return {
        type : ActionTypes.ADD_QUESTION_TO_PLAYLISTS_LOADING
    }
}

// array of responses
export const addedQuestionToPlaylists=(res)=>{
    return {
        type : ActionTypes.ADD_QUESTION_TO_PLAYLISTS,
        payload : res
    }
}

export const addQuestionToPlaylistError =()=>{
    return {
        type : ActionTypes.ADD_QUESTION_TO_PLAYLISTS_ERROR
    }
}

export const createPlaylist=(playlistName)=>{
    return {
        type: ActionTypes.CREATE_PLAYLIST,
        payload : playlistName
    }
}

export const craetePlaylistLoading=()=>{
    return {
        type : ActionTypes.CREATE_PLAYLIST_LOADING
    }
}

export  const createPlaylistError=()=>{
    return {
        type : ActionTypes.CREATE_PLAYLIST_ERROR
    }
}




export const fetchAddQuestionToPlaylist=(playlistId , questionId)=>(dispatch)=>{
    const options= {
        headers : {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
        }
    };
    console.log('my new playlistId =', playlistId);
    return new Promise((resolve , reject)=>{
        axios.post(Endpoints.endpoint_post_add_question_to_playlist,{ playlist_id : playlistId , question_id : questionId} , options)
            .then(res=>{resolve(res);})
            .catch(err=>{ reject(err)});
    })

}

export const fetchCreatePlaylist=(playlistName)=>(dispatch)=>{
    const options= {
        headers : {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
        }
    };
    console.log(' The playlist Name =', playlistName);
    return new Promise((resolve , reject)=>{
        axios.post(Endpoints.endpoint_post_create_playlist,{ name : playlistName} , options)
            .then(res=>{resolve(res); console.log('the playlist is created ! =', res.data)})
            .catch(err=>{ reject(err)});
    })
}


// I have to loop through all playlists
export const fetchAddQuestionToPlaylists=(playlists,   questionId)=>(dispatch)=>{
    return new Promise((resolve , reject)=>{
        // Array for promises when the playlists exists already
        const promises = [];
        playlists.forEach(playlistIdOrName=>{
            // It's an id for an existed playlist
            let newPromise;
            if( typeof playlistIdOrName === 'number'){
                newPromise = new Promise((resolve , reject)=>{
                    dispatch(fetchAddQuestionToPlaylist(playlistIdOrName , questionId))
                        .then(res=>{
                            resolve(res);
                        }).catch(err=>{
                        console.log( ' ERR ADD  1 QUESTION =', err);
                        reject(err);
                    })

                });
            }
            // It's a name of a new playlist
            else{
                newPromise = new Promise((resolve , reject)=>{
                    dispatch(fetchCreatePlaylist(playlistIdOrName))
                        .then(res=>{
                            return dispatch(fetchAddQuestionToPlaylist(res.data.data.id , questionId))
                        })
                        .then(res=>{
                            resolve(res);
                        }).catch(err=>{
                        reject(err);
                    })

                });
            }
            promises.push(newPromise);
        });
        // array for the  new playlists that i have to create before adding a question to them
        // newPlaylistsNameArr.forEach(playlistName=>{
        //     let newPromise = new Promise((resolve , reject)=>{
        //         dispatch(fetchCreatePlaylist(playlistName))
        //             .then(res=>{
        //                 dispatch(fetchAddQuestionToPlaylist(res.data.data.id , questionId))
        //             })
        //             .then(res=>{
        //                 resolve(res);
        //             }).catch(err=>{
        //             reject(err);
        //         })
        //
        //     });
        //     promises.push(newPromise);
        // });
        Promise.all(promises)
            .then(res=>{
                console.log('RES EXISTED PLAYLISTS = ', res);
                // dispatch(addedQuestionToPlaylists(res));
                resolve();
            })
            .catch(
                err=>{
                    console.log(' ERR EXISTED PLAYLISTS =' ,err);
                    dispatch(addQuestionToPlaylistError(err))
                    reject();
                }
            )
    });

}


const loginUserLoading=()=>{
    return {
        type : ActionTypes.LOGIN_USER_LOADING
    }
}

const loginUserError=(errObj)=>{
    console.log('ERROR LOGIN =', errObj);
    return {
        type : ActionTypes.LOGIN_USER_ERROR,
        payload : errObj
    }
}

const userLogged=(res)=>{
    return {
        type : ActionTypes.LOGIN_USER,
        payload : {
            token : res.token
        }
    }
}

export const fetchLoginUser=(email , password)=>(dispatch)=>{
    const options= {
        headers : {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin' : '*'
        }
    };
    dispatch(loginUserLoading());
    return new Promise((resolve , reject)=>{
        axios.post(Endpoints.endpoint_post_login_user, {email : email , password : password} , options)
            .then(res=>{dispatch(userLogged(res.data.success)); resolve()})
            .catch(err=>{dispatch(loginUserError(err.response.data)); reject();});
    })
}

const addCommentLoading=()=>{
    return {
        type : ActionTypes.ADD_COMMENT_LOADING
    }
}

const commentAdded =(comment )=>{
    return {
        type : ActionTypes.ADD_COMMENT,
        payload : comment
    }
}
const addCommentError =(err)=>{
    return {
        type : ActionTypes.ADD_COMMENT_ERROR,
        payload : err
    }
}

export const fetchAddComment=(questionId , comment)=>(dispatch)=>{
    const options= {
        headers : {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin' : '*'
        }
    };
    dispatch(addCommentLoading());
    return new Promise((resolve , reject)=>{
        axios.post(Endpoints.endpoint_post_add_comment, {question_id : questionId , note : comment} , options)
            .then(res=>{dispatch(commentAdded({questionId : questionId , comment : comment , createdAt : moment(res.data.data.created_at).format('MMMM Do YYYY, H:mm:ss') })); resolve()})
            .catch(err=>{dispatch(addCommentError(err.response.data.message)) ; reject()});
    })
}

// SUBMIT_CCQCM

export const getCommentLoading=()=>{
    return {
        type :ActionTypes.GET_COMMENT_LOADING
    }
}

export const getCommentError=(err)=>{
    return {
        type : ActionTypes.GET_COMMENT_ERROR
    }
}
export const getComment=(comment)=>{
    return {
        type : ActionTypes.GET_COMMENT,
        payload  : comment
    }
}


export const  fetchGetComment=(questionId)=>(dispatch , getState)=>{
    const headers = {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
    };
    return new Promise((resolve , reject)=>{
        let actualComment= getState().revision.comments.filter(commentData=>commentData.questionId == questionId).length ? getState().revision.comments.filter(commentData=>commentData.questionId == questionId)[0] : null
        // if i dont have yet the comment
        if(actualComment){
            dispatch(getCommentLoading());
            axios.get(Endpoints.endpoint_get_comment+questionId,
                { headers: headers }
            ).then(res=>{dispatch(getComment({comment : res.data.data.note , questionId : questionId , createdAt : res.data.data.created_at  }));resolve() })
                .catch(err=>{dispatch(getCommentError(err.response.data.message)); reject(); });
        }
        // I already stored it ! nothing todo
        else{
            resolve();
        }
    })


}

